import { FETCH_QUOTEID_DOCUMENTS } from './actiontypes';
import axios from 'axios';
import swal from 'sweetalert';

const BASE_URL = `https://operations.zunroof.com/api/documents`;

export function generateDocument(requestData) {
    return async (dispatch) => {
        try {
            swal("Generating document.. Please wait..");
            let apiResponse = await axios.post(`${BASE_URL}/generate`, requestData) || {};
            apiResponse = apiResponse.data || {};
            if(apiResponse.success) {
                swal(apiResponse.message || "Success");
                return;
            }
            swal(apiResponse.error || "Some error occured");
            return;
        }
        catch(error) {
            console.log("Error in generateDocument", error);
            swal("Some error occured");
            return;
        }
    }
}

export function fetchDocuments(quoteId) {
    return async (dispatch) => {
        try {
            let apiResponse = await axios.post(`${BASE_URL}/fetch`, { quoteId: quoteId }) || {};
            apiResponse = apiResponse.data || {};
            dispatch({ type: FETCH_QUOTEID_DOCUMENTS, payload: apiResponse.documents || [] })
            return;
        }
        catch(error) {
            console.log("Error in fetchDocuments", error);
            return;
        }
    }
}

export function downloadDocument(filePath, quoteId) {
    return async (dispatch) => {
        try {
            let apiResponse = await axios.post(`${BASE_URL}/download`, { filePath: filePath }) || {};
            apiResponse = apiResponse.data || {};
            console.log("apiResponse", apiResponse.url);
            if(!apiResponse.url) {
                alert("Some error occured");
                return;
            }
            // const a = document.createElement('a');
            // a.href = apiResponse.url;
            // a.download = `${quoteId}.pdf`;
            // document.body.appendChild(a);
            // a.click();
            // document.body.removeChild(a);
            window.open(apiResponse.url, '_blank');
            // const link = document.createElement('a');
            // link.href = apiResponse.url;
            // link.setAttribute('download', `${quoteId}.pdf`);
            // link.setAttribute('target', '_blank');
            // document.body.appendChild(link);
            // link.click();
            // document.body.removeChild(link);
            return;
        }
        catch(error) {
            console.log("Error in fetchDocuments", error);
            return;
        }
    }
}